import { ILocationSearchItemFragment } from 'transfix-maps/hooks/useLocationSearch'
import { getLocationLabel } from './getLocationLabel'

/**
 * getOptionLabel(option) // 'New York, NY'
 */
export const getOptionLabel = (option: ILocationSearchItemFragment): string => {
  const { address, city, country, postalCode, resultType, state, stateCode } = option || {}
  switch (resultType) {
    case 'Address':
      return address ?? ''
    case 'Country':
      return country ?? ''
    case 'POI':
      return address ?? ''
    case 'PostalCode':
      return [city, postalCode, state, country].filter(Boolean).join(', ')
    case 'State':
      return [state, country].filter(Boolean).join(', ')
    case 'City':
    case 'None':
    default:
      return getLocationLabel({
        city: city ?? '',
        state: stateCode ?? '',
        resultType: resultType ?? '',
        postalCode: postalCode ?? '',
      })
  }
}
